module.exports = __webpack_public_path__ + "img/klarna.60a63adf.png";